import React from 'react';

import {ReceivePaymentForm} from './components';
import './styles.css';

const ReceivePayment = ({
  tenancyId,
  delayExtraActions,
  invoice,
  xeroAccounts,
  getExtraActions,
  scheduleType,
  openConfirmPaymentModal,
  storeDataExtraActions,
  locationRef
}) => {
  return (
    <div className="ReceivePayment">
      <div className="horizontalLine" />
      <div className="header">Receive a payment</div>
      <ReceivePaymentForm
        tenancyId={tenancyId}
        delayExtraActions={delayExtraActions}
        invoice={invoice}
        scheduleType={scheduleType}
        xeroAccounts={xeroAccounts}
        getExtraActions={getExtraActions}
        openConfirmPaymentModal={openConfirmPaymentModal}
        storeDataExtraActions={storeDataExtraActions}
        locationRef={locationRef}
      />
      <div className="horizontalLine" />
    </div>
  );
};

export default ReceivePayment;
